import { render, staticRenderFns } from "./adjustment-table.vue?vue&type=template&id=2e1b0b55&scoped=true&"
import script from "./adjustment-table.vue?vue&type=script&lang=js&"
export * from "./adjustment-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b0b55",
  null
  
)

export default component.exports